import { IXetTotNghiepLanXetUpdateLockStatusRequest } from "../../model/request/xet-tot-nghiep/IXetTotNghiepLanXetUpdateLockStatusRequest";
import { IXetTotNghiepLanXet } from "../../model/response/xet-tot-nghiep/IXetTotNghiepLanXet";
import { apiClient } from "../apiClient";

export const XET_TOT_NGHIEP_LAN_XET = "xet-tot-nghiep-lan-xet";
export const xetTotNghiepLanXetApi = {
    SelectAll: () => apiClient.get(`${XET_TOT_NGHIEP_LAN_XET}`),
    Insert: (data: IXetTotNghiepLanXet) => apiClient.post(`${XET_TOT_NGHIEP_LAN_XET}`, data),
    Update: (id: number, data: IXetTotNghiepLanXet) => apiClient.put(`${XET_TOT_NGHIEP_LAN_XET}/${id}`, data),
    Delete: (id: number) => apiClient.delete(`${XET_TOT_NGHIEP_LAN_XET}/${id}`),
    UpdateLockStatus: (data: IXetTotNghiepLanXetUpdateLockStatusRequest) => apiClient.patch(`${XET_TOT_NGHIEP_LAN_XET}/trang-thai-khoa`, data),
}